// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"388f2cef","560":"5bb4d18c","572":"887056c3","634":"eae28eed","777":"b9014831","833":"acae115f"}[chunkId] + ".chunk.js";
};